import { Component, OnDestroy } from '@angular/core';
import {ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../../services/StorageService';
import { VenueService } from '../../../../services/VenueService';
import { Apiservice } from '../../../../services/ApiService';
import * as XLSX from 'xlsx';
import { environment } from '../../../../environments/environments';
import { ChartData } from 'chart.js';
import { AuthService } from '../../../../services/AuthService';
import * as pako from 'pako';


@Component({
  selector: 'app-share-feed',
  templateUrl: './share-feed.component.html',
  styleUrl: './share-feed.component.scss'
})
export class ShareFeedComponent implements OnDestroy {
  display: boolean = false;
shareKey: string | null = null;
private socket: WebSocket | null = null;
/** Guards against overlapping connects so a reconnect can't stack a second socket. */
private connecting: boolean = false;
venuelist: any[] = [];
Selectedvenue: string = '';
SelectedSession: string = '';
venueValue: string = '';
date: string = '';
currentDate = Date()
endDate: string = '';
dateRange: boolean = false;
loading: boolean = false;
attendanceSummary: any = {};
groupedInside: any = {}; 
displayData: boolean = true;
entranceGroupTable: any = [];
showSummary: boolean = false;
showGroup: boolean = false;
showEntrance: boolean = true;
showEvent: boolean = false;
showTicket: boolean = false;
showGraph: boolean = false;
manualSocketClose: boolean = false;
stopDataToggle: boolean = false;
LiveDate: string = '';
liveButton: boolean = false;
ninetyDaysAgo = new Date(new Date().getTime() - 90 * 24 * 3600 * 1000)
.toISOString()
.replace(/ GMT$/, '')
.split('T')[0];
astatreport: string = '';
latency: string = '';
timedGateEntries: any[] = [];  
selectedGates: string[] = [];  
chartData: ChartData = {
  labels: [],
  datasets: []
};
chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      title: {
        display: true,
        text: 'Time'
      }
    },
    y: {
      title: {
        display: true,
        text: 'Entries'
      }
    }
  }
};
processedTicketTypes: any[] = [];
// Sorted-row caches and per-table sort state powering the modern extended
// reporting tables (mirrors the authenticated /attendance page).
sortedEntranceKeysCache: string[] = [];
sortedEventKeysCache: string[] = [];
sortedGroupedKeysCache: string[] = [];
sortedTicketTypesCache: any[] = [];
sortState: {
  entrances: { key: string; dir: 'asc' | 'desc' };
  events: { key: string; dir: 'asc' | 'desc' };
  groupedEntries: { key: string; dir: 'asc' | 'desc' };
  ticketTypes: { key: string; dir: 'asc' | 'desc' };
} = {
  entrances: { key: 'name', dir: 'asc' },
  events: { key: 'name', dir: 'asc' },
  groupedEntries: { key: 'name', dir: 'asc' },
  ticketTypes: { key: 'database', dir: 'asc' },
};
venueTimezone: string = '';
sessions: any[] = [];
session: boolean = false;
selectedSessionTime: any = {};
sessionStart: string = '';
sessionEnd: string = '';
pastDate: number = 0;
useDarkMode: boolean = false;

constructor( private auth: AuthService,private storage: StorageService,private route: ActivatedRoute,public venue: VenueService, private apiservice: Apiservice) {
 }

setDarkMode(on: boolean): void {
  this.useDarkMode = on;
  document.body.classList.toggle('attendance-dark', on);
}

 parseTimedGateEntries(timedGateEntries: any): any[] {
  const gatesData: any[] = [];
  const timestampsSet = new Set<number>(); 

  if (timedGateEntries !== undefined) {
    Object.keys(timedGateEntries).forEach((gate) => {
      const gateData = {
        gate,
        entries: [] as number[],
        exits: [] as number[],
        reentries: [] as number[],
        internal: [] as number[],
        inVenue: [] as number[],
        timestamps: [] as number[],
        formattedTimestamps: [] as string[] 
      };

      Object.keys(timedGateEntries[gate]).forEach((utcTimestamp) => {
        const data = timedGateEntries[gate][utcTimestamp];

       
        const timestampNum = !isNaN(Number(utcTimestamp))
          ? Number(utcTimestamp)
          : new Date(utcTimestamp).getTime();

        if (!isNaN(timestampNum)) {
          timestampsSet.add(timestampNum);
          gateData.timestamps.push(timestampNum);
          gateData.formattedTimestamps.push(this.formatDate(new Date(timestampNum)));
          gateData.entries.push(Number(data?.entries || 0));
          gateData.exits.push(Number(data?.exits || 0));
          gateData.reentries.push(Number(data?.reentries || 0));
          gateData.internal.push(Number(data?.internal || 0));
          gateData.inVenue.push(Number(data?.inVenue || 0));
        } else {
          console.error("Invalid date:", utcTimestamp);
        }
      });

      gatesData.push(gateData);
    });

  
    const sortedTimestamps = Array.from(timestampsSet).sort((a, b) => a - b);
    const formattedTimestamps = sortedTimestamps.map(ts => this.formatDate(new Date(ts)));

  
    gatesData.forEach((gateData) => {
      const dataMap: { [key: number]: any } = {};
      gateData.timestamps.forEach((ts: number, idx: number) => {
        dataMap[ts] = {
          entries: gateData.entries[idx],
          exits: gateData.exits[idx],
          reentries: gateData.reentries[idx],
          internal: gateData.internal[idx],
          inVenue: gateData.inVenue[idx]
        };
      });

      gateData.timestamps = [];
      gateData.formattedTimestamps = [];
      gateData.entries = [];
      gateData.exits = [];
      gateData.reentries = [];
      gateData.internal = [];
      gateData.inVenue = [];

      sortedTimestamps.forEach(ts => {
        gateData.timestamps.push(ts);
        const data = dataMap[ts] || {
          entries: 0, exits: 0, reentries: 0, internal: 0, inVenue: 0
        };
        gateData.entries.push(data.entries);
        gateData.exits.push(data.exits);
        gateData.reentries.push(data.reentries);
        gateData.internal.push(data.internal);
        gateData.inVenue.push(data.inVenue);
      });
      
      gateData.formattedTimestamps = formattedTimestamps;
    });

    return gatesData;
  }

  return [];
}

formatDate(date: Date): string {

  
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: this.venueTimezone 
  };
  
  const formatted = date.toLocaleString('en-AU', options);
  return formatted;
}

updateChart(): void {
if (!this.timedGateEntries.length) return;

const allFormattedTimestamps = this.timedGateEntries[0]?.formattedTimestamps || [];

this.chartData.datasets = this.selectedGates.map((gate) => {
  const gateData = this.timedGateEntries.find(entry => entry.gate === gate);
  
  return {
    data: gateData?.entries || [],
    label: gate,
    borderColor: this.getRandomColor(),
    fill: true
  };
});

this.chartData.labels = allFormattedTimestamps;
}

toggleGateSelection(gate: string): void {
  const index = this.selectedGates.indexOf(gate);
  if (index === -1) {
    this.selectedGates.push(gate);
  } else {
    this.selectedGates.splice(index, 1);
  }
  this.updateChart();
}


getRandomColor(): string {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

sendMessage(message: string): void {
  if (this.socket?.readyState === WebSocket.OPEN) {
    this.socket.send(message);
  } else {
    console.error('WebSocket is not open. Cannot send message.');
  }
}

async getLiveData() {
  // Guard against overlapping connects: a dropped socket triggers a reconnect
  // via onclose, so without this two callers could each open a socket and leave
  // one orphaned (its frames never processed).
  if (this.connecting) return;
  this.connecting = true;

  // Tear the previous socket down before replacing it. Detaching its handlers
  // first stops its onclose from driving a second, competing reconnect that
  // would trample this.socket and orphan the live connection.
  this.teardownSocket();
  this.manualSocketClose = false;
  this.loading = true;

  const token = this.shareKey;
  const wsEndpoint = environment.wsEndpoint + token;

  const socket = new WebSocket(wsEndpoint);
  this.socket = socket;
  this.connecting = false;

  // Bind handlers to the local `socket` so they always reference this exact
  // connection, even if this.socket is later reassigned by a reconnect.
  socket.onopen = () => {
    console.log('WebSocket connection established.');
    this.manualSocketClose = false;
    this.sendMessage(this.shareKey ? this.shareKey : '');
  };

  socket.onmessage = (event) => {
    this.handleSocketMessage(event.data);
  };

  socket.onclose = () => {
    console.log('WebSocket connection closed.');
    // Ignore a stale socket's close once it's been replaced.
    if (socket !== this.socket) return;
    if (!this.manualSocketClose) {
      this.liveButton = false;
      this.getLiveData();
      console.log('WebSocket connection re-established.');
    } else {
      console.log('WebSocket is already closed');
    }
  };

  socket.onerror = () => {
    this.stopDataToggle = false;
    this.LiveDate = '';
  };
}

/**
 * Detaches the current socket's handlers and closes it. Nulling the handlers
 * first ensures the old socket's onclose can't fire a competing reconnect
 * after we've moved on to a new connection.
 */
private teardownSocket() {
  if (this.socket) {
    this.socket.onopen = null;
    this.socket.onmessage = null;
    this.socket.onclose = null;
    this.socket.onerror = null;
    this.socket.close();
    this.socket = null;
  }
}

// Decodes a WebSocket frame regardless of whether the feed sends raw JSON
// text, a base64-encoded gzip string, or a binary (Blob/ArrayBuffer) gzip
// frame, then applies the parsed payload. Mirrors the authenticated
// /attendance page so the shared report handles the same wire formats.
private async handleSocketMessage(data: any): Promise<void> {
  try {
    let text: string | null = null;

    if (typeof data === 'string') {
      text = this.maybeUngzipBase64(data);
    } else if (data instanceof Blob) {
      const buf = await data.arrayBuffer();
      text = this.bytesToText(new Uint8Array(buf));
    } else if (data instanceof ArrayBuffer) {
      text = this.bytesToText(new Uint8Array(data));
    } else {
      return;
    }

    if (!text) return;

    const payload = JSON.parse(text);
    this.applySocketPayload(payload);
  } catch (error) {
    console.error('Error handling socket message:', error);
  }
}

private maybeUngzipBase64(input: string): string | null {
  const trimmed = input.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    return trimmed;
  }
  if (!/^[A-Za-z0-9+/=\s]+$/.test(trimmed)) {
    return trimmed;
  }
  try {
    const binary = atob(trimmed.replace(/\s+/g, ''));
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return this.bytesToText(bytes);
  } catch {
    return trimmed;
  }
}

private bytesToText(bytes: Uint8Array): string {
  // gzip magic number (0x1f 0x8b) indicates the frame is compressed.
  if (bytes.length >= 2 && bytes[0] === 0x1f && bytes[1] === 0x8b) {
    return pako.ungzip(bytes, { to: 'string' });
  }
  return new TextDecoder('utf-8').decode(bytes);
}

private applySocketPayload(payload: any): void {
  if (!payload?.attendID) return;

  this.display = true;
  this.loading = false;
  this.stopDataToggle = true;
  // Frames are complementary slices of one report: the backend strips
  // events/ticketTypes/entrances from the timed frames and the timed series
  // from `main`. Merge rather than replace, or each timed frame would wipe
  // the tables the previous `main` frame populated.
  this.attendanceSummary = { ...(this.attendanceSummary || {}), ...payload };
  if (payload.groupedEntries !== undefined) {
    this.entranceGroupTable = payload.groupedEntries;
  }

  if (payload.timedGateEntries !== undefined) {
    this.timedGateEntries = this.parseTimedGateEntries(payload.timedGateEntries);
    this.chartData.labels =
      this.timedGateEntries.length > 0 ? this.timedGateEntries[0].timestamps : [];
    this.selectedGates = Object.keys(payload.timedGateEntries);
    this.updateChart();
  }

  this.groupedInside = {};
  for (const key in payload.groupedEntries || {}) {
    const entries = Number(payload.groupedEntries[key].entries || 0);
    const exits = Number(payload.groupedEntries[key].exits || 0);
    const reentries = Number(payload.groupedEntries[key].reentries || 0);
    this.groupedInside[key] = entries - exits + reentries;
  }

  if (payload.ticketTypes) {
    this.processTicketTypes();
  }

  this.refreshSortedCaches();
  this.LiveDate = '(Live Attendance)';
}

closeSocket() {
  if (this.socket) {
    // Mark intent before tearing down so any in-flight reconnect is suppressed.
    this.manualSocketClose = true;
    this.teardownSocket();
    console.log('WebSocket connection manually closed');
  } else {
    this.manualSocketClose = true;
    console.log('No active WebSocket connection to close.');
  }
}

liveData() {
this.getLiveData();
this.LiveDate = '(Live Attendance)';
this.stopDataToggle = true;
this.liveButton = false;
}

stopData() {
this.closeSocket();
this.stopDataToggle = false;
this.LiveDate = '';
this.liveButton = true;
}

downloadSummaryCSV() {
  const generateTableData = (header: string[], dataObject: any) => {
    const tableData = [header];
    for (let key of this.venue.objectKeys(dataObject)) {
      tableData.push([
        key,
        dataObject[key].entries,
        dataObject[key].exits,
        dataObject[key].internal,
        dataObject[key].reentries,
        dataObject[key].inVenue || dataObject[key].Inside,
      ]);
    }
    return tableData;
  };

 
  const summaryTableData = [
    ['Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
    [
      this.attendanceSummary.entries,
      this.attendanceSummary.exits,
      this.attendanceSummary.internal,
      this.attendanceSummary.reentries,
      this.attendanceSummary.inVenue,
    ],
  ];

 
  const entranceTableData = generateTableData(
    ['Gate Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
    this.attendanceSummary.entrances
  );

  const eventTableData = generateTableData(
    ['Event Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
    this.attendanceSummary.events
  );

  const ticketTableData = generateTableData(
    ['DATABASE | Event | Ticket Type', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
    this.attendanceSummary.ticketTypes
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(summaryTableData), 'Attendance Summary');
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(entranceTableData), 'Entrance Summary');
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(eventTableData), 'Event Summary');
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(ticketTableData), 'Ticket Type Summary');

 
  if (this.attendanceSummary.groupedEntries) {
    const groupedEntranceTableData = generateTableData(
      ['Event Name', 'Entries', 'Exits', 'Internal', 'Reentries', 'Inside'],
      this.attendanceSummary.groupedEntries
    );
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(groupedEntranceTableData), 'Grouped Entrance Summary');
  }

  const venueObject = this.venuelist.find(venue => venue.key === this.Selectedvenue)
  this.venueValue = venueObject && venueObject.value ? venueObject.value.name : '';

  XLSX.writeFile(workbook, this.venueValue + "_"  + this.date + '.xlsx');
}


private tableSections: (keyof Pick<ShareFeedComponent, 
  'showSummary' | 'showGroup' | 'showEntrance' | 'showEvent' | 'showTicket' | 'showGraph'
>)[] = ['showSummary', 'showGroup', 'showEntrance', 'showEvent', 'showTicket', 'showGraph'];

toggleTable(section: keyof ShareFeedComponent): void {
  this.tableSections.forEach(sec => {
    this[sec] = sec === section ? !this[sec] : false;
    localStorage.setItem(sec, String(this[sec]));
    localStorage.setItem(
      `buttonClicked${sec.charAt(0).toUpperCase() + sec.slice(1)}`,
      String(this[sec])
    );
  });
}

toggleDateRangeCheckBox(){
  if (this.dateRange == true){
    return true;
  }
  else{
    return false;
  }
}

getASTATFile(event: any) {
  this.loading = true;
  this.apiservice.getASTAT(this.Selectedvenue, this.date).subscribe(
    (result: string) => {
      this.astatreport = result;
      this.downloadAstatCSV();
      this.loading = false;
    },
    (error: any) => {
      console.error('Error fetching ASTAT file:', error);
      this.loading = false;
    }
  );
}

downloadAstatCSV() {
  const blob = new Blob([this.astatreport], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  const venueObject = this.venuelist.find(venue => venue.key === this.Selectedvenue)
  this.venueValue = venueObject && venueObject.value ? venueObject.value.name : '';

  a.download = this.venueValue + '_' + this.date + '.csv';

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}


deselectAll() {
  this.selectedGates = []; 
  this.updateChart();  
}

processTicketTypes() {
  this.processedTicketTypes = Object.keys(this.attendanceSummary.ticketTypes).map(key => {
    const parts = key.split('|');
    return {
      database: parts[0] || '',
      event: parts[1] || '',
      ticketType: parts[2] || '',
      ...this.attendanceSummary.ticketTypes[key]
    };
  });
}

toggleSort(table: keyof ShareFeedComponent['sortState'], key: string): void {
  const current = this.sortState[table];
  if (current.key === key) {
    current.dir = current.dir === 'asc' ? 'desc' : 'asc';
  } else {
    current.key = key;
    current.dir =
      key === 'name' || key === 'database' || key === 'event' || key === 'ticketType'
        ? 'asc'
        : 'desc';
  }
  this.refreshSortedCaches();
}

sortIndicator(table: keyof ShareFeedComponent['sortState'], key: string): string {
  const s = this.sortState[table];
  if (s.key !== key) return '';
  return s.dir === 'asc' ? '▲' : '▼';
}

refreshSortedCaches(): void {
  this.sortedEntranceKeysCache = this.sortKeyedRows(this.attendanceSummary?.entrances, 'entrances').map((r) => r.key);
  this.sortedEventKeysCache = this.sortKeyedRows(this.attendanceSummary?.events, 'events').map((r) => r.key);
  this.sortedGroupedKeysCache = this.sortKeyedRows(this.attendanceSummary?.groupedEntries, 'groupedEntries').map((r) => r.key);

  const list = [...this.processedTicketTypes];
  const { key, dir } = this.sortState.ticketTypes;
  list.sort((a, b) => this.compareValues(a?.[key], b?.[key], dir));
  this.sortedTicketTypesCache = list;
}

private compareValues(a: any, b: any, dir: 'asc' | 'desc'): number {
  const an = Number(a);
  const bn = Number(b);
  const aNum = !isNaN(an) && a !== null && a !== '';
  const bNum = !isNaN(bn) && b !== null && b !== '';
  let cmp: number;
  if (aNum && bNum) {
    cmp = an - bn;
  } else {
    cmp = String(a ?? '').localeCompare(String(b ?? ''));
  }
  return dir === 'asc' ? cmp : -cmp;
}

private sortKeyedRows(
  obj: { [key: string]: any } | undefined | null,
  table: keyof ShareFeedComponent['sortState']
): { key: string; row: any }[] {
  if (!obj) return [];
  const rows = Object.keys(obj).map((key) => ({ key, row: obj[key] }));
  const { key: sortKey, dir } = this.sortState[table];
  rows.sort((a, b) => {
    let av: any;
    let bv: any;
    if (sortKey === 'name') {
      av = a.key;
      bv = b.key;
    } else if (sortKey === 'inVenue' && table === 'groupedEntries') {
      av = this.groupedInside[a.key] ?? 0;
      bv = this.groupedInside[b.key] ?? 0;
    } else {
      av = a.row?.[sortKey];
      bv = b.row?.[sortKey];
    }
    return this.compareValues(av, bv, dir);
  });
  return rows;
}

ngOnInit(): void {
  this.display = true;
  this.shareKey = this.route.snapshot.queryParamMap.get('key');


  this.getLiveData();
}

ngOnDestroy(): void {
  // Tear down the live feed and clear the dark-mode class so it doesn't leak
  // onto other pages after navigating away from the shared report.
  this.manualSocketClose = true;
  this.closeSocket();
  document.body.classList.remove('attendance-dark');
}



fetchData(key: string): void {
  console.log('Fetching data for key:', key);
}




}


